import { User } from 'types';
import { PermissionCheck } from '../types';

type CheckFn = (user: User) => boolean;

export function createPermission(fn: CheckFn): PermissionCheck {
  return Object.assign(fn as PermissionCheck, {
    and: (otherCheck: CheckFn) =>
      createPermission((user) => fn(user) && otherCheck(user)),
    or: (otherCheck: CheckFn) =>
      createPermission((user) => fn(user) || otherCheck(user))
  });
}
